import { Link } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import { Box, Grid, styled } from '@mui/material'
import { useMemo } from 'react'
import { CommonPrivacy } from 'features/common'
import { Group } from 'features/groups'

import { privateOptionDescriptor } from '../ShareOptionPrivate'
import { SharedOptionDescription, sharedOptionDescriptor } from '../ShareOptionShared/ShareOptionShared'
import ShareOptionLabel, { ShareOptionLabelProps } from '../ShareOptionLabel'
import { RoundedIconSize } from '../../RoundedIcon'

interface ResourceSharingSectionProps {
  size?: RoundedIconSize
  privacy: CommonPrivacy
  groups?: Group[]
  onManage: () => void
}

const ManageOptionsGridLink = styled(Grid, { shouldForwardProp: (prop) => prop !== 'size' })<{ size: RoundedIconSize }>(
  ({ theme, size }) => ({
    '&.MuiGrid-item': {
      paddingTop: 0,
      ...(size === 'small' ? { paddingLeft: theme.spacing(8.5) } : { paddingLeft: theme.spacing(9.5) }),
      [theme.breakpoints.down('md')]: {
        ...(size === 'small' ? { paddingLeft: theme.spacing(7.75) } : { paddingLeft: theme.spacing(8.75) })
      }
    }
  })
)

function ResourceSharingSection({ privacy, groups, size = 'medium', onManage }: ResourceSharingSectionProps) {
  const sharedOptions: Record<string, ShareOptionLabelProps> = useMemo(() => {
    return {
      [CommonPrivacy.Private]: {
        ...privateOptionDescriptor
      },
      [CommonPrivacy.Shared]: {
        ...sharedOptionDescriptor,
        description: groups?.length ? <SharedOptionDescription groups={groups} /> : sharedOptionDescriptor.description,
        selected: true
      }
    }
  }, [groups])

  const currentShareOption = sharedOptions[privacy]
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ShareOptionLabel {...currentShareOption} size={size} />
      </Grid>
      <ManageOptionsGridLink item xs={12} size={size}>
        <Box>
          <Link onClick={onManage} variant="caption" fontWeight={500} color="primary">
            <FormattedMessage id={'apps.create.common.manageOptions'} />
          </Link>
        </Box>
      </ManageOptionsGridLink>
    </Grid>
  )
}

export default ResourceSharingSection
